"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Menu = require("../../components/menu-list/Menu");
var _Button = require("../button/Button");
var _IconButton = _interopRequireDefault(require("../button/IconButton"));
var _utility = require("../utility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var maxWidth = 768; // above medium device
var minWidth = 320; // small device
var buttonWidth = 992;
var defaultTablePageSizeOptions = ["25", "50", "100"];
var oldPage = 0;
var upClass = "toggle-up";
var downClass = "toggle-down";
var PaginationV1 = /*#__PURE__*/function (_React$Component) {
  _inherits(PaginationV1, _React$Component);
  var _super = _createSuper(PaginationV1);
  function PaginationV1(props) {
    var _this;
    _classCallCheck(this, PaginationV1);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "pageListRef", /*#__PURE__*/(0, _react.createRef)());
    _defineProperty(_assertThisInitialized(_this), "selectDropdownOne", function (event, id) {
      var buttonState = !_this.state.isOpenOne;
      _this.iconToggle(buttonState, id);
      _this.setState({
        isOpenOne: buttonState
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDownOne", function (event) {
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this.setState({
          isOpenOne: !_this.state.isOpenOne
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onClickHandler", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this.setState({
          isOpen: !_this.state.isOpen
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getOptionsNumber", function (page, index, array) {
      var myJSON = '{ "displayText": "1", "itemId": "menu item 1", "subheader": false, "disabled": false }';
      var options = [];
      var totalPage = array[array.length - 1];
      var item = JSON.parse(myJSON);
      if (array[index] <= page) {
        for (var i = 1; i <= totalPage; i++) {
          item = {};
          item.displayText = parseInt(i.toString());
          item.subheader = false;
          item.disabled = false;
          item.itemId = i.toString();
          options.push(item);
        }
      }
      return options;
    });
    _defineProperty(_assertThisInitialized(_this), "selectOne", function (event) {
      _this.setState({
        selectedPgOne: event.target.getAttribute("data-item"),
        page: event.target.getAttribute("data-item"),
        isOpen: false
      });
      _this.changePage(event.target.getAttribute("data-item") - 1);
    });
    _defineProperty(_assertThisInitialized(_this), "filterPages", function (visiblePages, totalPages) {
      return visiblePages.filter(function (page) {
        return page <= totalPages;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getVisiblePages", function (page, total) {
      total = parseInt(total);
      if (total < 7) {
        return _this.filterPages([1, 2, 3, 4, 5, 6], total);
      } else {
        return _this.filterPages([1, 2, total - 1, total], total);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onPageSizeValChange", function (page) {
      _this.props.onPageSizeChange(page);
      _this.selectDropdownOne(page, "tl-button-1");
      _this.setState({
        isOpenOne: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updatePage", function (page) {
      _this.setState({
        page: page,
        pageUpdated: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onClickOutside", function (e) {
      var _this$pageListRef$cur;
      if (!((_this$pageListRef$cur = _this.pageListRef.current) !== null && _this$pageListRef$cur !== void 0 && _this$pageListRef$cur.contains(e.target))) {
        _this.setState({
          isOpen: false
        });
      }
    });
    _this.getSafePage = _this.getSafePage.bind(_assertThisInitialized(_this));
    _this.changePage = _this.changePage.bind(_assertThisInitialized(_this));
    _this.applyPage = _this.applyPage.bind(_assertThisInitialized(_this));
    _this.selectOne = _this.selectOne.bind(_assertThisInitialized(_this));
    _this.state = {
      page: props.page,
      pageUpdated: false,
      minWidth: 0,
      isOpenOne: false,
      selectedPgOne: props.selectedPgOne
    };
    _this.updateDimensions = _this.updateDimensions.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(PaginationV1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions, false);
      document.addEventListener("click", this.onClickOutside, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions, false);
    }
  }, {
    key: "iconToggle",
    value: function iconToggle(isOpen, id) {
      var iconId = "#" + id + " span svg";
      var className = document.querySelector(iconId);
      if (className && className.classList) {
        if (isOpen) {
          className.classList.replace(downClass, upClass);
        } else {
          className.classList.replace(upClass, downClass);
        }
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(data) {
      this.setState({
        selectedComponent: data
      });
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      if (window.innerWidth < maxWidth) {
        this.setState({
          width: minWidth
        });
      } else {
        this.setState({
          width: window.innerWidth
        });
      }
    }
  }, {
    key: "getSafePage",
    value: function getSafePage(page) {
      if (Number.isNaN(page)) {
        page = this.props.page;
      }
      return Math.min(Math.max(page, 0), this.props.pages - 1);
    }
  }, {
    key: "changePage",
    value: function changePage(page) {
      page = this.getSafePage(page);
      this.setState({
        page: page,
        pageUpdated: false
      });
      if (this.props.page !== page) {
        this.props.onPageChange(page);
      }
    }
  }, {
    key: "applyPage",
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }
      var page = this.state.page;
      this.changePage(page === "" ? this.props.page : page);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$resolvedD,
        _this2 = this;
      var _this$props = this.props,
        pages = _this$props.pages,
        pageSize = _this$props.pageSize,
        canPrevious = _this$props.canPrevious,
        totalRecordLength = _this$props.totalRecordLength,
        restorePageNumber = _this$props.restorePageNumber,
        pageSizeOptions = _this$props.pageSizeOptions,
        pageLabel = _this$props.pageLabel,
        paginationDropdownHide = _this$props.paginationDropdownHide,
        hasOutLine = _this$props.hasOutLine;
      var defaultTablePageSize = pageSizeOptions !== null && pageSizeOptions !== void 0 && pageSizeOptions.length ? pageSizeOptions : defaultTablePageSizeOptions;
      var _this$props2 = this.props,
        page = _this$props2.page,
        canNext = _this$props2.canNext;
      if (restorePageNumber && !this.state.pageUpdated) {
        if (page === oldPage) {
          oldPage = page;
          page = 0;
        }
      }
      oldPage = page;
      canNext = canNext === false && page === 0 ? true : canNext;
      var visiblePages = this.getVisiblePages(page + 1, pages);
      var activePage = page + 1;
      var firstRecord = page * pageSize;
      var lastRecord = firstRecord + pageSize;
      var totalRecords = totalRecordLength;
      var resolveDataLength = (_this$props$resolvedD = this.props.resolvedData) === null || _this$props$resolvedD === void 0 ? void 0 : _this$props$resolvedD.length;
      totalRecords = totalRecords ? totalRecords : resolveDataLength;
      lastRecord = lastRecord >= totalRecords ? totalRecords : lastRecord;
      var dropdownOptions = defaultTablePageSize.map(function (data, index) {
        return {
          displayText: data,
          itemId: data,
          selectable: index === 0 ? true : false
        };
      });
      var showDropdown = dropdownOptions.length ? totalRecords > dropdownOptions[0].displayText ? true : resolveDataLength ? true : false : false;
      var showPages = pages > 1 ? true : false;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-pagination-wrapper tl-pagination-wrapper-v1",
        id: "lazy"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: hasOutLine ? "page-info-outline" : "page-info"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "pagination-text-count --make-center"
      }, "".concat(firstRecord + 1, "-").concat(lastRecord), " "), /*#__PURE__*/_react.default.createElement("span", {
        className: "pagination-text-light --make-center"
      }, "of", " "), /*#__PURE__*/_react.default.createElement("span", {
        className: "pagination-text-bold --make-center"
      }, "".concat(totalRecords), " "), !paginationDropdownHide && showDropdown && /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _utility.classNames)(hasOutLine ? "pagination-text-light pagination-records-outline" : "pagination-text-light pagination-records", '--make-center')
      }, showPages ? pageLabel ? pageLabel : "Items per page" : ""), !paginationDropdownHide && showDropdown && /*#__PURE__*/_react.default.createElement("div", {
        className: hasOutLine ? "pagination-dropdown-outline" : "pagination-dropdown"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-menu-list-wrapper tl-menuList-primary-dropdown-pg"
      }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
        tabIndex: 0,
        onKeyDown: this.onKeyDownOne,
        id: "tl-button-1",
        name: "label-1",
        variant: "primary",
        size: "small",
        type: "dropdownButtonPg",
        icon: "icon-system-download",
        onClick: function onClick(event) {
          return _this2.selectDropdownOne(event, "tl-button-1");
        },
        className: "tl-button-primary-active-pg tl-button-page-size"
      }, pageSize), this.state.isOpenOne && /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
        menuListId: "example-new",
        buttonId: "tl-button-1",
        selectedDropdown: this.selectDropdownOne,
        label: "",
        className: "tl-menu-list-pg-dropdown",
        menuItems: dropdownOptions,
        onOptionClick: function onOptionClick(e) {
          return _this2.onPageSizeValChange(parseInt(e.target.id.substring(0, 3)));
        },
        value: pageSize,
        highlightSelected: true
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: hasOutLine ? "tl-pagination-col-item-left-right-outer-outline" : "tl-pagination-col-item-left-right page-info"
      }, showPages && /*#__PURE__*/_react.default.createElement("div", {
        className: "pg-button-wrapper text"
      }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
        onClick: function onClick() {
          if (!canPrevious) return;
          var selectedPgOne = parseInt(_this2.state.selectedPgOne) + 1;
          _this2.setState({
            selectedPgOne: selectedPgOne
          });
          _this2.changePage(page - 1);
        },
        variant: "primary",
        iconPosition: "left",
        disabled: !canPrevious,
        size: "small",
        icon: "icon-system-arrow1-left",
        className: "tl-pagination-navigation tl-page-previous"
      }, this.state.width > buttonWidth ? "Previous" : ""), visiblePages.map(function (page, index, array) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: index
        }, array[index - 1] + 2 <= page && /*#__PURE__*/_react.default.createElement("div", {
          ref: _this2.pageListRef,
          className: "tl-page-list"
        }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          tabIndex: 0,
          outline: false,
          active: false,
          onClick: _this2.onClickHandler,
          events: {
            onKeyDown: _this2.onKeyDown
          },
          icon: 'icon-system-ellipsis'
        }), _this2.state.isOpen && /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
          menuListId: "example-pg",
          label: "Form Label",
          className: "tl-menu-list-pg",
          menuItems: _this2.getOptionsNumber(page, index, array),
          onOptionClick: _this2.selectOne,
          value: activePage,
          highlightSelected: true
        }))), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          tabIndex: 0,
          active: activePage === page,
          onClick: function onClick() {
            var selectedPgOne = parseInt(page);
            _this2.setState({
              selectedPgOne: selectedPgOne,
              isOpen: false
            });
            _this2.changePage(page - 1);
          },
          number: page
        }));
      }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        tabIndex: 0,
        onClick: function onClick() {
          if (!canNext) return;
          var selectedPgOne = parseInt(_this2.state.selectedPgOne) + 1;
          _this2.setState({
            selectedPgOne: selectedPgOne
          });
          _this2.changePage(page + 1);
        },
        disabled: !canNext,
        variant: "primary",
        size: "small",
        className: "tl-pagination-navigation tl-page-next"
      }, this.state.width > buttonWidth ? "Next" : ""))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.page !== state.page) {
        return {
          page: props.page
        };
      }
      return null;
    }
  }]);
  return PaginationV1;
}(_react.default.Component);
exports.default = PaginationV1;